import { createSlice } from '@reduxjs/toolkit';
import {
  saveGoalTemplate,
  deleteBoxTemplate,
  getBoxesTemplates,
  getCategoryTemplates,
  getGoalTemplates,
  saveBoxTemplate,
  updateCategory,
  deleteGoalTemplate,
} from './fourBoxesTemplatesActions';

const initialState = {
  isLoading: false,
  listLoading: false,
  boxTemplates: [],
  categoriesLoading: false,
  categoryTemplates: [],
  goalsLoading: false,
  goalTemplates: [],
  error: null,
  success: false,
};

const boxTemplatesSlice = createSlice({
  name: 'boxTemplates',
  initialState,
  reducers: {},
  extraReducers: {
    // get 4boxes templates
    [getBoxesTemplates.pending]: state => {
      state.listLoading = true;
    },
    [getBoxesTemplates.fulfilled]: (state, { payload }) => {
      state.listLoading = false;
      state.boxTemplates = payload.data;
    },
    [getBoxesTemplates.rejected]: (state, { payload }) => {
      state.listLoading = false;
      state.error = payload;
    },
    // save template
    [saveBoxTemplate.pending]: state => {
      state.listLoading = true;
    },
    [saveBoxTemplate.fulfilled]: (state, { payload }) => {
      state.listLoading = false;
      state.boxTemplates =
        payload.status === 200
          ? state.boxTemplates.map(template => {
              if (template.id === payload.data.id) {
                return payload.data;
              }
              return template;
            })
          : [...state.boxTemplates, payload.data];
    },
    [saveBoxTemplate.rejected]: (state, { payload }) => {
      state.listLoading = false;
      state.error = payload;
    },
    // delete template
    [deleteBoxTemplate.pending]: state => {
      // state.listLoading = true;
    },
    [deleteBoxTemplate.fulfilled]: (state, { payload }) => {
      state.boxTemplates = state.boxTemplates.filter(
        template => template.id !== payload.id
      );
      state.listLoading = false;
    },
    [deleteBoxTemplate.rejected]: (state, { payload }) => {
      state.listLoading = false;
      state.error = payload;
    },
    // get category templates
    [getCategoryTemplates.pending]: state => {
      state.categoriesLoading = true;
    },
    [getCategoryTemplates.fulfilled]: (state, { payload }) => {
      state.categoriesLoading = false;
      state.categoryTemplates = payload.data;
    },
    [getCategoryTemplates.rejected]: (state, { payload }) => {
      state.categoriesLoading = false;
      state.error = payload;
    },
    // get goal templates
    [getGoalTemplates.pending]: state => {
      state.goalsLoading = true;
    },
    [getGoalTemplates.fulfilled]: (state, { payload }) => {
      state.goalsLoading = false;
      state.goalTemplates = payload.data;
    },
    [getGoalTemplates.rejected]: (state, { payload }) => {
      state.goalsLoading = false;
      state.error = payload;
    },
    // update category
    // [updateCategory.pending]: state => {
    //   state.loading = true;
    // },
    [updateCategory.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.boxTemplates = state.boxTemplates.map(template => {
        if (template.id === payload.templateId) {
          return {
            ...template,
            goal_category_templates: [
              ...template.goal_category_templates.map(cat => {
                if (cat.id === payload.id) {
                  return payload;
                }
                return cat;
              }),
            ],
          };
        }

        return template;
      });
    },
    [updateCategory.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // add goal item
    [saveGoalTemplate.pending]: state => {
      state.loading = true;
    },
    [saveGoalTemplate.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.boxTemplates = state.boxTemplates.map(template => {
        if (template.id === payload.templateId) {
          return {
            ...template,
            goal_category_templates: [
              ...template.goal_category_templates.map(cat => {
                if (cat.id === payload.goalCategoryTemplateId) {
                  if (payload.isCreating) {
                    return {
                      ...cat,
                      goal_templates: [...cat.goal_templates, payload],
                    };
                  }
                  return {
                    ...cat,
                    goal_templates: [
                      ...cat.goal_templates.map(goal => {
                        if (goal.id === payload.id) {
                          return payload;
                        }
                        return goal;
                      }),
                    ],
                  };
                }
                return cat;
              }),
            ],
          };
        }

        return template;
      });
    },
    [saveGoalTemplate.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // delete goal template
    [deleteGoalTemplate.pending]: state => {
      // state.listLoading = true;
    },
    [deleteGoalTemplate.fulfilled]: (state, { payload }) => {
      // state.listLoading = false;
      state.boxTemplates = state.boxTemplates.map(template => {
        if (template.id === payload.templateId) {
          return {
            ...template,
            goal_category_templates: [
              ...template.goal_category_templates.map(cat => {
                if (cat.id === payload.category.id) {
                  return {
                    ...cat,
                    goal_templates: [
                      ...cat.goal_templates.filter(
                        goal => goal.id !== payload.goalId
                      ),
                    ],
                  };
                }
                return cat;
              }),
            ],
          };
        }

        return template;
      });
    },
    [deleteGoalTemplate.rejected]: (state, { payload }) => {
      // state.listLoading = false;
      state.error = payload;
    },
  },
});

export default boxTemplatesSlice.reducer;
